import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mine",
  "use": "icon-mine-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-mine\">\r\n<style type=\"text/css\">\r\n\t#icon-mine .st0{fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-miterlimit:10;}\r\n</style>\r\n<circle class=\"st0\" cx=\"100\" cy=\"72.6\" r=\"48.5\" />\r\n<path class=\"st0\" d=\"M29.2,181.8c0,0,2.1-46.1,41-62\" />\r\n<path class=\"st0\" d=\"M144.7,130.5c0,0,25.5,15.2,25.5,52.9\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/mine.svg
// module id = AsYQ
// module chunks = 9